import {find, findAll} from "../../../../../modules/vegas/js/util";

/**
 * Скрыть / показать комментарии к отзыву
 */
[...document.querySelectorAll('.review')].forEach(function (review) {
	let $toggleComment = find('.comment-show-link', review);

	if ($toggleComment) {
		let $toggleCommentText = find('span', $toggleComment),
			target = $toggleComment.getAttribute('href'),
			$collapse = find(target, review);

		$collapse.addEventListener('hide.bs.collapse', event => {
			$toggleCommentText.innerText = 'Показать ответы';
		})

		$collapse.addEventListener('show.bs.collapse', event => {
			$toggleCommentText.innerText = 'Скрыть ответы';
		})
	}
});

/**
 * Ставим рейтинг
 */
[...document.querySelectorAll('[data-vg-rating]')].forEach(function (element) {
	let input = element.getAttribute('data-input');

	findAll('[data-vg-toggle="rating"]', element).forEach(function (toggleRating){
		toggleRating.onclick = function () {
			let $rate = this,
				star = parseInt($rate.getAttribute('data-star'));

			element.setAttribute('data-rating-value', star)
			document.querySelector('input[name=' + input + ']').value = star;

			return false;
		}
	});
});
